import React, { useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import Avatar from "./retro/avatar/avatar.component";
import "./CollapsibleMemberGroup.scss";

// Presentation only: pass the normal member rows as children.
export default function CollapsibleMemberGroup({
  title = "Workspace members",
  icon,
  members = [],
  maxAvatars = 4,
  avatarSize = 28,
  defaultOpen = false,
  className = "",
  indent = 0,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const [hasOpened, setHasOpened] = useState(defaultOpen);
  const visible = members.slice(0, Math.max(0, maxAvatars));
  const remaining = members.length - visible.length;

  return (
    <section
      className={`collapsible-member-group${open ? " is-open" : ""} ${className}`}
      style={{ marginLeft: indent }}
    >
      <button
        type="button"
        className="collapsible-member-group__header"
        aria-expanded={open}
        onClick={() => {
          setHasOpened(true);
          setOpen((value) => !value);
        }}
      >
        {icon}
        <span className="collapsible-member-group__title">{title}</span>
        {!open && (
          <span
            className="collapsible-member-group__avatars"
            aria-hidden="true"
          >
            {visible.map((member, index) => (
              <span
                key={member.uid}
                className="collapsible-member-group__avatar"
                style={{
                  width: avatarSize,
                  height: avatarSize,
                  zIndex: visible.length - index,
                }}
              >
                <Avatar user={member} size={avatarSize} tiny />
              </span>
            ))}
            {remaining > 0 && (
              <span title={`${remaining} more members`}>…</span>
            )}
          </span>
        )}
        <FaChevronRight
          className={`collapsible-member-group__chevron${open ? " is-open" : ""}`}
          size={12}
          aria-hidden="true"
        />
      </button>
      <div
        className="collapsible-member-group__reveal"
        aria-hidden={!open}
        {...(!open ? { inert: "" } : {})}
      >
        <div className="collapsible-member-group__clip">
          <div className="collapsible-member-group__list">
            {hasOpened ? children : null}
          </div>
        </div>
      </div>
    </section>
  );
}
